import { render, staticRenderFns } from "./CartaoDespesas.vue?vue&type=template&id=0c5d5b0c&scoped=true"
import script from "./CartaoDespesas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDespesas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDespesas.vue?vue&type=style&index=0&id=0c5d5b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d5b0c",
  null
  
)

export default component.exports